import { isEmpty, isEqual, keys, uniqWith } from 'lodash';

const ADDITIONAL_PARAMS_QUERY_STRING = 'additionalParams=';
export const isIFrame = () => {
  try {
    return window.self !== window.top && window.name === 'ii-salesforce';
  } catch (e) {
    return false;
  }
};

export const isBrokerageIframe = () => {
  try {
    return window.self !== window.top && window.name === 'brokerage-experience';
  } catch (e) {
    return false;
  }
};

export const getQueryStringParams = (routerSearch) => {
  const paramCookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(ADDITIONAL_PARAMS_QUERY_STRING));
  let params = [];

  if (routerSearch) {
    params = routerSearch
      .replace('?', '')
      .split('/&|?/')
      .map((pair) => {
        if (pair) {
          const keyValues = pair.split('=');
          return { [keyValues[0]]: keyValues[1] };
        }
      });
  }

  if (isEmpty(params) && window && window.location && window.location.search) {
    params = window.location.search
      .substring(1, window.location.search.length)
      .split('&')
      .map((pair) => {
        if (pair) {
          const keyValues = pair.split('=');
          return { [keyValues[0]]: keyValues[1] };
        }
      });
  }

  if (paramCookie && paramCookie.length) {
    const cookieParams = paramCookie.split(ADDITIONAL_PARAMS_QUERY_STRING);
    const transferredParams = cookieParams.length > 0 ? cookieParams[1] : '';
    const regex = new RegExp('[&|?]');
    transferredParams.split(regex).forEach((pair) => {
      if (pair) {
        const keyValues = pair.split('=');
        const parsedParam = { [keyValues[0]]: keyValues[1] };
        const update = params.findIndex(
          (param) =>
            isEqual(keys(param), keys(parsedParam)) &&
            !isEqual(param, parsedParam)
        );
        if (update == -1) {
          // add
          params.push(parsedParam);
        } else {
          // update
          params.splice(update, 1, keyValues[1]);
        }
      }
    });
  }
  return uniqWith(params, isEqual);
};

export const addBrowserCookie = (name, value) => {
  document.cookie = `${name}=${value}; path=${window.location.host}; Secure;`;
};

export const removeBrowserCookie = (name) => {
  // Validate the name parameter
  if (!/^[a-zA-Z0-9-_]+$/.test(name)) {
    throw new Error('Invalid cookie name');
  }

  if (document && document.cookie && name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Secure; path=${window.location.host};`;
  }
};

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const setCookie = (name, value, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expiration = 'expires=' + d.toUTCString();
  document.cookie =
    name + '=' + value + ';' + expiration + ';domain=.troweprice.com;path=/';
};

export const hasBrowserCookie = (name) => {
  return document && document.cookie && Boolean(getCookie(name));
};

export const clearAllCookies = () => {
  document.cookie
    .split(';')
    .forEach((cookie) => removeBrowserCookie(cookie.split('=')[0]));
};

export const getCookieValue = (cookieString, cookieName) => {
  return ('; ' + cookieString).split(`; ${cookieName}=`).pop().split(';')[0];
};

export const addQueryStringParam = (existing, param, value) => {
  return existing.indexOf('?') !== -1
    ? existing + '&' + param + '=' + value
    : existing + '?' + param + '=' + value;
};

export const buildQueryParamString = () => {

  const getAdditionalParamsFromCookie = () => document.cookie
    .split('; ')
    .find((row) => row.startsWith(ADDITIONAL_PARAMS_QUERY_STRING));

  const queryStringFromAdditionalParams = getAdditionalParamsFromCookie()?.replace(ADDITIONAL_PARAMS_QUERY_STRING, "");

  if(queryStringFromAdditionalParams){
    return queryStringFromAdditionalParams;
  }


  if(document && document.location && document.location.search){

    return document.location.search
  }

  return '';
};

